import React, { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";
import { messaging } from "../lib/firebase";
import { getToken, onMessage } from "firebase/messaging";
import Endpoint from "../Endpoint";

const VAPID_KEY =
    "BD_B_59hrI45ytsL3KDVQTPCx_wDoFvcQiJDzPXm7ivYaDRBheFkm6IsQoeF79XEdvzEmfbxkV89mHi-vAHcGBM";

const NotificationFirebasePrompt = ({ onNotification = () => { } }) => {
    const [token, setToken] = useState(null);
    const [message, setMessage] = useState(null);

    useEffect(() => {
        const registerServiceWorkerAndGetToken = async () => {
            try {
                const permission = await Notification.requestPermission();
                if (permission !== "granted") {
                    console.warn("🚫 Permiso de notificaciones no concedido");
                    return;
                }

                const registration = await navigator.serviceWorker.register(
                    "/firebase-messaging-sw.js"
                );

                await navigator.serviceWorker.ready;

                const currentToken = await getToken(messaging, {
                    vapidKey: VAPID_KEY,
                    serviceWorkerRegistration: registration,
                });

                if (currentToken) {
                    setToken(currentToken);
                    const userId = localStorage.getItem("iduht");

                    if (userId) {
                        await fetch(`${Endpoint}/fcm-token`, {
                            method: "POST",
                            body: JSON.stringify({ token: currentToken, userId }),
                            headers: { "Content-Type": "application/json" },
                        });
                    }
                } else {
                    console.warn("⚠️ No se obtuvo token FCM");
                }
            } catch (err) {
                console.error("❌ Error al registrar SW o pedir token:", err);
            }
        };

        registerServiceWorkerAndGetToken();

        const unsubscribe = onMessage(messaging, (payload) => {
            setMessage(payload.notification?.body || "Mensaje recibido");
            onNotification(payload);
        });

        return () => unsubscribe();
    }, [onNotification]);

    return (
        <></>
    );
};

export default NotificationFirebasePrompt;

/* ================= Styled Components ================= */

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
`;

const Container = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  background: #ffffff;
  padding: 14px 20px;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  font-size: 14px;
  color: #1f2937;
  width: 300px;
  animation: ${fadeIn} 0.25s ease;
  z-index: 9999;
`;

const Status = styled.div`
  font-weight: 500;
  color: ${({ success }) => (success ? "#16a34a" : "#6b7280")};
  margin-bottom: 8px;
`;

const Message = styled.div`
  background: #f9fafb;
  border-radius: 8px;
  padding: 10px 12px;
  border: 1px solid #e5e7eb;
  h4 {
    font-size: 14px;
    font-weight: 600;
    color: #111827;
    margin: 0 0 4px 0;
  }
  p {
    margin: 0;
    font-size: 13px;
    color: #374151;
  }
`;